export default class WorkPlanCreateCtrl {

	constructor ($scope, $resource, WorkPlanParametrizationSrv, $stateParams, $mdDialog) {
		const createVM = this

		// VARIABLES
		createVM.subTitle = 'Diligencie los datos en el siguiente formulario.'
		createVM.workplan = {}
		createVM.currentPage = 0
		createVM.subPeriods = null
		createVM.minStartDate = moment().toDate()
		createVM.minDateEndDate = new Date()
		createVM.workplan.start_date = null
		createVM.workplan.end_date = null
		createVM.isDisabled = false
		createVM.stages = []
		createVM.periods = []
		let cloning = false

		// METHODS
		createVM.hasError = hasError
		createVM.showErrorMessages = showErrorMessages
		createVM.validateDates = validateDates
		createVM.validateStagesDates = validateStagesDates
		createVM.getPreviousStage = getPreviousStage
		createVM.startDateChange = startDateChange
		createVM.getFormAttribute = getFormAttribute
		createVM.initStages = initStages
		createVM.moveToPage = moveToPage
		createVM.periodSelected = periodSelected
		createVM.validateForm = validateForm
		createVM.subPeriodSelected = subPeriodSelected
		createVM.showWorkPlanName = showWorkPlanName
		createVM.showPage = showPage
		createVM.saveWorkplan = saveWorkplan
		createVM.showModalWorkPlanCreated = showModalWorkPlanCreated
		createVM.formatDates = formatDates

		// SERVICES DEFINITION
		function activate () {
			return getStage().then(getPeriodicity().then(cloneWP()))
		}

		function getStage () {
			return WorkPlanParametrizationSrv.getStage.get().$promise.then(function (dataReturn) {
				if (dataReturn.status === true) {
					createVM.stages = dataReturn.data
					createVM.initStages()
				}
			})
		}

		function getPeriodicity () {
			return WorkPlanParametrizationSrv.getPeriodicity.get().$promise.then(function (dataReturn) {
				if (dataReturn.status === true) {
					createVM.periods = dataReturn.data
				}
			})
		}

		// for cloning a workplan
		function cloneWP () {
			let header = { id: $stateParams.workPlanId }

			if ($stateParams != null && $stateParams.workPlanId != null) {
				cloning = true

				return WorkPlanParametrizationSrv.getWorkPlan.get(header).$promise.then((dataReturn) => {
					if (dataReturn.status === true) {
						createVM.workplan = dataReturn.data
						createVM.workplan.start_date = moment(dataReturn.data.start_date).toDate()
						createVM.workplan.end_date = moment(dataReturn.data.end_date).toDate()
						createVM.workplan.plan_name = ''
						createVM.subPeriods = createVM.workplan.period.options
						periodSelectedCloning(createVM.workplan.period)
						for (let period in createVM.workplan.subperiod.dates) {
							createVM.workplan.subperiod.dates[period].start_date = moment(createVM.workplan.subperiod.dates[period].start_date).toDate()
							createVM.workplan.subperiod.dates[period].end_date = moment(createVM.workplan.subperiod.dates[period].end_date).toDate()
							createVM.subPeriods[period].start_date = moment(createVM.workplan.subperiod.dates[period].start_date).toDate()
							createVM.subPeriods[period].end_date = moment(createVM.workplan.subperiod.dates[period].end_date).toDate()
						}
						for (let stage in createVM.workplan.stages) {
							createVM.workplan.stages[stage].start_date = moment(createVM.workplan.stages[stage].start_date).toDate()
							createVM.workplan.stages[stage].end_date = moment(createVM.workplan.stages[stage].end_date).toDate()
						}
					}
				})
			}
		}

		// METHODS DEFINITION
		function hasError (input) {
			if (input.$invalid && (input.$dirty || input.$touched)) {
				return 'has-error'
			}
		}

		function showErrorMessages (input) {
			return input.$dirty || input.$touched
		}

		function validateDates () {
			if (createVM.subPeriods) {
				if (createVM.subPeriods.showOnlyDateInputs) {
					createVM.datePeriod = {}
					let subPeriod

					for (subPeriod in createVM.subPeriods) {
						if (createVM.subPeriods[subPeriod].id_code) {
							let periodId = createVM.subPeriods[subPeriod].id_code
							let minStartDate, maxStartDate, minEndDate, maxEndDate
							let m = moment(createVM.workplan.end_date)

							maxStartDate = m.isValid() ? m.subtract(1, 'days').toDate() : null
							m = moment(createVM.workplan.end_date)
							maxEndDate = m.isValid() ? m.toDate() : null
							m = moment(createVM.workplan.subperiod.dates[ periodId ].start_date)
							minEndDate = m.isValid() ? m.add(1, 'days').toDate() : null

							if (createVM.datePeriod[ periodId - 1]) {
								m = moment(createVM.workplan.subperiod.dates[ periodId - 1 ].end_date)
								minStartDate = m.isValid() ? m.toDate() : null
							} else {
								m = moment(createVM.workplan.start_date)
								minStartDate = m.isValid() ? m.toDate() : null
							}

							createVM.datePeriod[ periodId ] = {
								minStartDate: minStartDate,
								maxStartDate: maxStartDate,
								minEndDate  : minEndDate,
								maxEndDate  : maxEndDate,
							}
						}
					}
				} else {
					let subPeriodId = createVM.workplan.subperiod.id_code

					createVM.datePeriod = {}
					let m = moment(createVM.workplan.start_date)
					let minStartDate = m.isValid() ? m.toDate() : null

					m = moment(createVM.workplan.end_date)
					let maxStartDate = m.isValid() ? m.subtract(1, 'days').toDate() : null

					m = moment(createVM.workplan.subperiod.dates[ subPeriodId ].start_date)
					let minEndDate = m.isValid() ? m.add(1, 'days').toDate() : null

					m = moment(createVM.workplan.end_date)
					let maxEndDate = m.isValid() ? m.toDate() : null

					createVM.datePeriod[ subPeriodId ] = {
						minStartDate: minStartDate,
						maxStartDate: maxStartDate,
						minEndDate  : minEndDate,
						maxEndDate  : maxEndDate,
					}
				}
			}
		}

		function validateStagesDates () {
			createVM.stageDates = {}
			for (let i = createVM.stages.length - 1; i >= 0; i--) {
				let stageCode = createVM.stages[i].id_code
				let stageName = createVM.stages[i].ds_name
				let m, minStartDate, maxStartDate, minEndDate, maxEndDate

				m = moment(createVM.workplan.end_date)
				maxStartDate = m.isValid() ? m.subtract(1, 'days').toDate() : null
				m = moment(createVM.workplan.stages[ stageCode ].start_date)
				minEndDate = m.isValid() ? m.add(1, 'days').toDate() : null
				m = moment(createVM.workplan.end_date)
				maxEndDate = m.isValid() ? m.toDate() : null
				switch (stageName) {

				case 'Planeación':
					m = moment(createVM.workplan.start_date)
					minStartDate = m.isValid() ? m.toDate() : null
					break
				case 'Revisión de planeación':
					m = moment(createVM.workplan.stages[ createVM.stageCodes['Planeación'].id_code ].start_date)
					minStartDate = m.isValid() ? m.toDate() : null
					break
				case 'Aprobación':
					m = moment(createVM.workplan.stages[ createVM.stageCodes['Planeación'].id_code ].start_date)
					minStartDate = m.isValid() ? m.toDate() : null
					break
				case 'Ejecución':
					m = moment.max(
						moment(createVM.workplan.stages[ createVM.stageCodes['Planeación'].id_code ].end_date),
						moment(createVM.workplan.stages[ createVM.stageCodes['Revisión de planeación'].id_code ].end_date),
						moment(createVM.workplan.stages[ createVM.stageCodes['Aprobación'].id_code ].end_date),
					)
					minStartDate = m.isValid() ? m.add(1, 'days').toDate() : null
					break
				case 'Revisión de la ejecución':
					m = moment.max(
						moment(createVM.workplan.stages[ createVM.stageCodes['Planeación'].id_code ].end_date),
						moment(createVM.workplan.stages[ createVM.stageCodes['Revisión de planeación'].id_code ].end_date),
						moment(createVM.workplan.stages[ createVM.stageCodes['Aprobación'].id_code ].end_date),
					)
					minStartDate = m.isValid() ? m.add(1, 'days').toDate() : null
					break
				case 'Seguimiento':
					m = moment(createVM.workplan.start_date)
					minStartDate = m.isValid() ? m.toDate() : null
					break
				case 'Evaluación':
					m = moment(createVM.workplan.stages[ createVM.stageCodes['Ejecución'].id_code ].end_date)
					minStartDate = m.isValid() ? m.add(1, 'days').toDate() : null
					break
				default:
					let previousStage = createVM.getPreviousStage(createVM.stages[i])

					if (previousStage) {
						m = moment(createVM.workplan.stages[ previousStage.id_code ].end_date)
					} else {
						m = moment(createVM.workplan.start_date)
					}

					minStartDate = m.isValid() ? m.toDate() : null
					break
				
				}
				createVM.stageDates[ stageCode ] = {
					minStartDate: minStartDate,
					maxStartDate: maxStartDate,
					minEndDate  : minEndDate,
					maxEndDate  : maxEndDate,
				}
			}
		}

		function getPreviousStage (currentStage) {
			let element = createVM.stages.filter(function (stage) {
				return stage.nm_order === currentStage.nm_order - 1
			})

			return element.length === 1 ? element[0] : null
		}

		function startDateChange () {
			let m = moment(createVM.workplan.start_date)

			createVM.minDateEndDate = m.isValid() ? m.add(1, 'days').toDate() : null
			createVM.validateDates()
			createVM.validateStagesDates()
		}

		function getFormAttribute (form, attr, index) {
			attr = attr + index

			return form[attr]
		}

		function initStages () {
			createVM.workplan.stages = {}
			createVM.stageCodes = {}
			createVM.stages.sort(function (a, b) { return a.nm_order - b.nm_order })
			for (let i = createVM.stages.length - 1; i >= 0; i--) {
				let stageId = createVM.stages[i].id_code
				let stageName = createVM.stages[i].ds_name

				createVM.stageCodes[ stageName ] = createVM.stages[i]
				createVM.workplan.stages[ stageId ] = {
					start_date: null,
					end_date  : null,
				}
			}
		}

		function moveToPage (pageNumber) {
			if (pageNumber && pageNumber >= 0) {
				createVM.currentPage = pageNumber        
			} else {
				createVM.currentPage = 0
			}
		}

		function periodSelected (period) {
			createVM.subPeriods = period.options

			if (!createVM.workplan.subperiod) {
				createVM.workplan.subperiod = {} 
			}
		
			if (period.ds_name === 'Anual') {
				createVM.subPeriods.showOnlyDateInputs = true
				createVM.workplan.subperiod.id_code = period.id_code
				createVM.workplan.subperiod.ds_name = period.ds_name
				createVM.workplan.subperiod.dates = {}
				let subPeriod

				for (subPeriod in createVM.subPeriods) {
					if (createVM.subPeriods[subPeriod].id_code) {
						let periodId = createVM.subPeriods[subPeriod].id_code

						createVM.workplan.subperiod.dates[periodId] = {
							start_date: moment(createVM.subPeriods[subPeriod].start_date).format('YYYY-MM-DD'),
							end_date  : moment(createVM.subPeriods[subPeriod].end_date).format('YYYY-MM-DD'),
						}
					}
				}
				createVM.validateDates()
			} else {
				createVM.subPeriods.showOnlyDateInputs = false
				let subPeriod

				for (subPeriod in createVM.subPeriods) {
					if (createVM.subPeriods[subPeriod] && (createVM.subPeriods[subPeriod].id_code == createVM.workplan.subperiod.id_code)) {
						let periodId = createVM.subPeriods[subPeriod].id_code

						createVM.workplan.subperiod.dates[periodId] = {
							start_date: moment(createVM.subPeriods[subPeriod].start_date).format('YYYY-MM-DD'),
							end_date  : moment(createVM.subPeriods[subPeriod].end_date).format('YYYY-MM-DD'),
						}
					}
				}

				if (createVM.workplan.subperiod.id_code) {
					createVM.validateDates()
				}
			}
		}

		function periodSelectedCloning (period) {
			if (period.ds_name === 'Anual') {
				createVM.subPeriods.showOnlyDateInputs = true
				createVM.workplan.subperiod.id_code = period.id_code
				createVM.workplan.subperiod.ds_name = period.ds_name
			} else {
				createVM.subPeriods.showOnlyDateInputs = false
			}
		}

		function validateForm (form) {
			return form.$invalid
		}

		function subPeriodSelected (subPeriod) {
			createVM.workplan.subperiod.ds_name = subPeriod.ds_name
			createVM.workplan.subperiod.dates = {}
			createVM.workplan.subperiod.dates[subPeriod.id_code] = {
				start_date: null,
				end_date  : null,
			}
			createVM.validateDates()
		}

		function showWorkPlanName () {
			let planName = 'Nuevo Plan'

			if (createVM.workplan && createVM.workplan.plan_name && createVM.workplan.plan_name !== '') {
				planName = createVM.workplan.plan_name
			}

			return planName
		}

		function showPage (page) {
			if (createVM.currentPage === 1) {
				createVM.subTitle = 'Verifique las fechas correspondientes a las etapas del plan de trabajo.'
			}

			return page === createVM.currentPage
		}

		function saveWorkplan () {
			createVM.isDisabled = true
			let workplan = createVM.formatDates()

			if (cloning) {
				workplan.workPlanIdCloned = $stateParams.workPlanId
				WorkPlanParametrizationSrv.cloneWorkPlan.add(workplan).$promise.then(function (dataReturn) {
					if (dataReturn.status === true) {
						createVM.workplan.id_code = dataReturn.data[0].insertId
						createVM.showModalWorkPlanCreated()
					} else {
						createVM.isDisabled = false
					}
				})
			} else {
				WorkPlanParametrizationSrv.addWorkplan.add(workplan).$promise.then(function (dataReturn) {
					if (dataReturn.status === true) {
						createVM.workplan.id_code = dataReturn.data[0].insertId
						createVM.showModalWorkPlanCreated()
					} else {
						createVM.isDisabled = false
					}
				})
			}
		}

		function showModalWorkPlanCreated () {
			let planName = createVM.workplan.plan_name
			let workPlanId = createVM.workplan.id_code

			$mdDialog.show({
				controller: [ '$scope', '$mdDialog', function ($scope, $mdDialog) {
					$scope.planName = planName
					$scope.workPlanId = workPlanId
					$scope.close = function () {
						$mdDialog.hide()
					}
				} ],
				template           : require('./modalWorkPlanCreated.html'),
				clickOutsideToClose: false,
			})
		}

		function formatDates () {
			let workplan = angular.copy(createVM.workplan)

			workplan.start_date = moment(workplan.start_date).format('YYYY-MM-DD')
			workplan.end_date = moment(workplan.end_date).format('YYYY-MM-DD')
			let subperiodDate

			for (subperiodDate in workplan.subperiod.dates) {
				workplan.subperiod.dates[subperiodDate].start_date = moment(workplan.subperiod.dates[subperiodDate].start_date).format('YYYY-MM-DD')
				workplan.subperiod.dates[subperiodDate].end_date = moment(workplan.subperiod.dates[subperiodDate].end_date).format('YYYY-MM-DD')
			}
			let stage

			for (stage in workplan.stages) {
				workplan.stages[stage].start_date = moment(workplan.stages[stage].start_date).format('YYYY-MM-DD')
				workplan.stages[stage].end_date = moment(workplan.stages[stage].end_date).format('YYYY-MM-DD')
			}

			return workplan
		}

		// INITIALIZATION
		activate()
	}//FIN DEL CONSTRUCTOR
	preventInput(event) {
		var vKey = 86

		if (event.keyCode == vKey)
			event.preventDefault()

		return     
	}

}

WorkPlanCreateCtrl.$inject = [ '$scope', '$resource', 'WorkPlanParametrizationSrv', '$stateParams', '$mdDialog' ]



// WEBPACK FOOTER //
// ./src/app/u-faculty/workPlanParametrization/create/workPlanCreateCtrl.js